<script>
    import {getGPTransFunc} from "./gp-translations.js";
    import GPDetails from "./gp-details.svelte";
    import {GPMisc} from "./gp-misc";
    let trans = getGPTransFunc("gp-itemdetails");

    export let type;
    let inside;

    let bigimgsrc;

    let hitext;
    let hiinchtext;
    let ditext;
    let diinchtext;

    let alternativeNames;
    let blooming;
    let bloomFrom;
    let bloomTo;
    let lightFull;
    let lightHalf;
    let lightDark;

    export function open() {
        if (type.height_from && type.height_to) {
            hitext = toTextMeters(type.height_from) + '-' + toTextMeters(type.height_to);
            hiinchtext = toFeet(type.height_from) + '-'+ toFeet(type.height_to);
        } else {
            hitext = toTextMeters(type.height);
            hiinchtext = toFeet(type.height);
        }

        if (type.diameter) {
            ditext = toTextMeters(type.diameter);
            diinchtext = toFeet(type.diameter);
        }

        if (type.blossom_from) {
            blooming = true;
            bloomFrom = GPMisc.roman[type.blossom_from - 1];
            bloomTo = GPMisc.roman[type.blossom_to - 1];
        } else blooming = false;

        bigimgsrc = type.staticGetPathForImage(type.best_season);
        let parts = bigimgsrc.split('\\');
        bigimgsrc = parts.join('\\\\');

        alternativeNames = type.alternativeNames;
        lightFull = type.light_full;
        lightHalf = type.light_half;
        lightDark = type.light_dark;

        inside.open();
    }

    function toFeet(n) {
      var realFeet = ((n*0.393700) / 12);
      var feet = Math.floor(realFeet);
      var inches = Math.round((realFeet - feet) * 12);
      if (feet === 0) return inches + '"';
      if (feet > 3) return feet + "' ";
      return feet + "' " + inches + '"';
    }

    function toTextMeters(n) {
        if (n<=200)
            return n+"cm"
        else {
            var meters = Math.round(n * 10) / 1000;
            return meters + "m";
        }
    }


</script>

<GPDetails type="{type}" bind:this={inside}>
    <div class="thumbarea">
        <div class="thumb" style="background-image: url('{bigimgsrc}');"/>
        {#if ditext}<div class="measurementDiameter"><span>{diinchtext} ({ditext})</span></div>{/if}
        <div class="measurementHeight"><div><span>{hiinchtext} ({hitext})</span></div></div>
    </div>

    <div class="description">
        {#if alternativeNames}<p><strong>{trans("Alternative names")}:</strong> {alternativeNames}</p>{/if}
        <p><strong>{trans("Latin name")}:</strong> {type.latin}</p>
        {#if ditext}<p><strong>{trans("Diameter")}:</strong> {diinchtext} ({ditext})</p>{/if}
        <p><strong>{trans("Height")}:</strong> {hiinchtext} ({hitext})</p>
        {#if blooming}<p><strong>{trans("Bloom time")}:</strong>
            {#if bloomFrom !== bloomTo}
                {bloomFrom} - {bloomTo}
            {:else}
                {bloomFrom}
            {/if}
        </p>{/if}
        <p><strong>{trans("Light requirements")}:</strong> {#if lightFull}<img src="img/nicons/sun.svg"/>{/if} {#if lightHalf}<img src="img/nicons/sun_half.svg"/>{/if} {#if lightDark}<img src="img/nicons/sun_none.svg"/>{/if}</p>
        <p>{type.details}</p>
    </div>
</GPDetails>